// --------------------------------------------------------------------------
// GTM tracking ga3 u ga4
// --------------------------------------------------------------------------



// mora biti window.gtm_Tracking kako bni ga koristio Vue
window.gtm_Tracking = {

	init: function() {
		console.log("init gtm_Tracking")
		this.bindTrackAnchor();

	},

	bindTrackAnchor: function() {

		var self = this;

		if($("a.gtm-event").length > 0)
		{
			$("a.gtm-event").each(function(){

				$(this).on("click", function(e){

					var anchorHref = $(this).attr("href");
					var eventCategory = $(this).attr("data-ga-category");
					var eventAction = $(this).attr("data-ga-action");
					var eventLabel = $(this).attr("data-ga-label");
					var eventValue = $(this).attr("data-ga-value");
					var eventNonInteraction = $(this).attr("data-ga-noninteraction");
					var eventOutbound = $(this).attr("data-ga-outbound") == undefined ? false : true;
					var callbackFunction = false;

					////console.log("a.gtm-event", anchorHref, eventOutbound);

					if(eventCategory!==undefined && eventCategory!="" && eventAction!==undefined && eventAction!="")
					{
						if(!eventOutbound)
						{
							e.preventDefault();
							callbackFunction = function(){
								location.href = anchorHref;
							}
						}

						self.trackEvent(eventCategory, eventAction, eventLabel, eventValue, eventNonInteraction, callbackFunction);
					}
				});

			});
		}

		var filetypes = /\.(zip|exe|pdf|doc*|xls*|ppt*|mp3)$/i;
		var baseHref = '';
		if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');

		jQuery('a:not(.gtm-event)').each(function() {

			var href = jQuery(this).attr('href');

			if (href && href.match(/^mailto\:/i))
			{
				jQuery(this).click(function() {
					var mailLink = href.replace(/^mailto\:/i, '');

					// ga tracking
					gtm_Tracking.trackEvent('Email', 'click', mailLink, 1);
				});
			}
			else if (href && href.match(filetypes))
			{
				jQuery(this).click(function(e) {
					var extension = (/[.]/.exec(href)) ? "-" + /[^.]+$/.exec(href) : '';

					// ga tracking
					gtm_Tracking.trackEvent('Download', 'click' + extension, href, 1);
				});
			}

		});

	},

	/**
	 * gtm_Tracking.trackEvent('test', 'console', 'Arena', 1);
	 *
	 * dataLayer.push({"event":"GAEvent","eventCategory":"test","eventAction":"console","eventLabel":"Arena","eventValue":1});
	 */
	trackEvent: function(category, action, label, value, noninteraction, cb) {

		////console.log("trackEvent", category, action, label);

		var eventLabel = label == undefined ? '' : label;
		var eventValue = value == undefined ? '' : value;
		var eventNonInteraction = noninteraction == undefined ? false : noninteraction;
		var callbck = cb == undefined ? false : cb;

		var obj = {
			'event': 'GAEvent',
			'eventCategory': category,
			'eventAction': action,
			'eventLabel': eventLabel,
			'eventValue': eventValue,
			'eventNonInteraction': eventNonInteraction
		};

		if(callbck)
		{
			obj.eventCallback = callbck;
		}

		if(typeof dataLayer !== 'undefined')
		{
			dataLayer.push(obj);
		}
	},

	// old ga3
	// ne koristi se trenutno nigdje (ne poziva se iz vue bookinga)
	trackNetwork: function(category, action, target) {

		////console.log("trackNetwork", category, action, target);
		if(typeof dataLayer !== 'undefined')
		{
			dataLayer.push({
				'event': 'GAEvent',
				'socialNetwork': category,
				'socialAction': action,
				'socialTarget': target
			});
		}

	},

	// Ecommerce Measurement

	// old ga3 
	// ne koristi se trenutno nigdje (ne poziva se iz vue bookinga)
	trackEcommerceProductImpressions: function(products, category, variant, list, currencyCode) {

		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(list === undefined) list = 'Hotel room list';
		if(currencyCode === undefined) currencyCode = 'EUR';

		var dataToPush = {
			'ecommerce': {
				'currency': currencyCode,
				'impressions': []
			}
		};

		products.forEach(function(element, index) {

			var itemToPush = {
				'name': element['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
				'id': element['id'], // '12345',
				'price': element['price'], // '15.25',
				'brand': 'Arenahotels', // 'Google',
				'category': category, // 'Apparel',
				'variant': variant, // 'Gray',
				'list': list, // 'Search Results',
				'position': index+1
			};

			dataToPush.ecommerce.impressions,push(itemToPush);

		});

		// console.log("trackEcommerceProductImpressions", dataToPush);

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
			dataLayer.push(dataToPush);
		}

	},

	// novo ga4 2023
	trackEcommerceViewItemList: function(filters, results) {
		console.log("trackEcommerceViewItemList", arguments);

		var products = [];
		var position = 0;
		for(var i=0;i<results.result.length;i++){

			var property = results.result[i];
			position++;

			var productPrice = 0;
			var property_id = '';
			var property_name = '';      
			var accommodation_type = '';      
			if (property['savedData'] !== undefined) {
				property_id = property.savedData.property_id;
				property_name = property.savedData.name;
			}

			if (property["savedData"]["articleData"] !== undefined && property["savedData"]["articleData"]["custom_fields"] !== undefined) {
				// if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
				if (property.savedData.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.savedData.articleData.custom_fields.accommodation_type
				// if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
			}
			
			if (property["cheapestRate"] !== undefined && property["cheapestRate"]["Price"] !== undefined) {
				productPrice = property.cheapestRate.Price;
			}

			var product = {
				item_id: property_id, // "1234",   //hotel id
				item_name: property_name, // " Park Plaza Arena",  //hotel name
				index: position,       // The index/position of the item in a list.
				item_category: accommodation_type, // "Regular",  // The category of the item (if any)
				price: productPrice,
			}
			products.push(product);
			

		}

		// kreiranje naziva liste (analizirajuci upaljene filtere na booking result list pageu)
		var list_name = "List";
		if (filters["and_group"] !== undefined) {

			for(var i=0;i<filters.and_group.length;i++){
				var filter = filters.and_group[i];

				if (filter["is_active"] !== undefined && filter.is_active == true) {

					if (filter["criteria"] !== undefined && filter["criteria"]["phobsData"] !== undefined) {

						if (filter.criteria.phobsData["Property"] !== undefined && filter.criteria.phobsData.Property["City"] !== undefined) {
							list_name = list_name + " " + filter.criteria.phobsData.Property.City;
						}

						if (filter.criteria.phobsData["Property"] !== undefined && filter.criteria.phobsData.Property["attr"] !== undefined && filter.criteria.phobsData.Property.attr["Type"]) {
							list_name = list_name + " " + filter.criteria.phobsData.Property.attr.Type;
						}
					}
				}

			}
		}

		// 2023 GA4
		var dataToPush = {
			event: "view_item_list",
			ecommerce: {
				item_list_name: list_name, // the name of the hotel list depands on the page
				items: products,
			}
		}                

		console.log("view_item_list dataLayer dataToPush", dataToPush);

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
			// dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		}


	},

	// novo 12-2023
	// gurnut cemo veliku listu dobivenih unita za potrebe trackanja duetto quotes-a
	trackEcommerceViewUnitsList: function(arrival, departure, property_id, units) {
		console.log("main.js - trackEcommerceViewUnitsList", arguments);

		// ovo inicijaliziramo u index.html a ovdje samo pushamo u window.duetto
		// (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'capture.duettoresearch.com/assets/js/duetto/duetto.js'; var n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(s, n); })();        
		var low_price = 0;
		var high_price = 0;
		var unitlist = [];

		for (var i = 0; i < units.length; i++) {
			var name = units[i].phobsData.name;
			// console.log(name);

			var unitRatesObj = units[i].phobsData.rates; // ovo je obj i mora se forEach-ati
			Object.keys(unitRatesObj).forEach(key => {
			// console.log(key, unitRatesObj[key]);

				var variationObj = unitRatesObj[key].variations;

				if (variationObj !== undefined) {

					Object.keys(variationObj).forEach(vkey => {

						var rateID = variationObj[vkey].rateID;
						// console.log(rateID);
						var ratePrice = parseFloat(variationObj[vkey].Price);  // hmm ili iz realPrice ????
						if (ratePrice > high_price) high_price = ratePrice;
						if (ratePrice < low_price || low_price == 0 ) low_price = ratePrice;
						unitlist.push({
							"rate": ratePrice,
							"roomType": name,
							"rateCode": rateID,
						});       

					});

				} else {

					var rateID = unitRatesObj[key].rateID;
					// console.log(rateID);
					var ratePrice = parseFloat(unitRatesObj[key].Price);  // hmm ili iz realPrice ????
					if (ratePrice > high_price) high_price = ratePrice;
					if (ratePrice < low_price || low_price == 0 ) low_price = ratePrice;
					unitlist.push({
						"rate": ratePrice,
						"roomType": name,
						"rateCode": rateID,
					});       
				}

		 
			});

		}

		window.duetto = {
			appId: "duetto_id", // assigned by duetto
			tld: "arenahotels.com",
		  
			events: [{  
				't': 's', //s for search
				'h': property_id, // '{{hotelId}}',
				'lr': low_price, // '{{searchLowRate}}', //user specified minimum rate to show (optional)
				'hr': high_price, // '{{searchHighRate}}', //user specified maximum rate to show (optional)
				'sd': arrival, // '{{arrival}}' //arrival date (yyyy-MM-dd)
				'ed': departure, // '{{departure}}' //departure date (yyyy-MM-dd)
			}]
		};
		
		var quotes = [];
		for (var i = 0; i < unitlist.length; i++) {
			var quote = unitlist[i];
			quotes.push({
				'r' : quote.rate, //the room rate for a single night or adr
				'rt' : quote.roomType, //room type
				'rc' : quote.rateCode //rate code
			});
		};
		
		window.duetto.events.push({
			't': 'q', //q for quote
			'h': property_id, // '{{hotelId}}',
			'qq' : quotes,
			'sd': arrival, // '{{arrival}}', //arrival date (yyyy-MM-dd)
			'ed': departure, // '{{departure}}' //departure date (yyyy-MM-dd)
		});  


	},


	// done
	trackEcommerceAddToCart: function(room, category, hotelName, currencyCode, props) {

	// trackEcommerceAddToCart: function(room, category, hotelName, currencyCode, dimensions, props) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(hotelName === undefined) hotelName = '';
		if(currencyCode === undefined) currencyCode = 'EUR';

		console.log("trackEcommerceAddToCart", arguments);

		if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

			//find chosen rate
			if (room.unitData.rateName.includes(" - ")) {


				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				} else{

					var segments = room.unitData.rateName.split(" - ");

					if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
						var rate = room.unitData.phobsData.rates[segments[0]];
					}
				}


			} else {

				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				}
			}

			// ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
			var property_id = '';
			var property_name = '';
			var google_places_api_id = '';
			var accommodation_type = '';
			var accommodation_city = '';
			if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
				property_id = room.unitData.savedData.property_id;
			}

			if (props !== undefined && props['property'] !== undefined) {
				var property = props['property'];
				if (property.property_id !== undefined) property_id = property.property_id;
				if (property.name !== undefined) property_name = property.name;

				if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
					if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
					if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
					if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
				}
			}

			if (rate !== undefined) {

				//find the correct rate variation
				if (rate.variations !== undefined) {
					if (rate.variations[room.unitData.board] !== undefined) {
						rate = rate.variations[room.unitData.board];
					} else {
						return;
					}
				}

				// fallback price
				var productPrice = '0';
				if(room.price !== undefined)
				{
					productPrice = parseFloat(room.price);
				}
				else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
					productPrice = rate.specialStayTotal.Price;
				}
				else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
				{
					productPrice = rate.StayTotal.Price;
				}
				else
				{
					productPrice = rate.Price;
				}

				// 2023 GA4
				var dataToPush = {
					event: "add_to_cart",
					ecommerce: {
					  currency: currencyCode, // EUR
					 value: productPrice,    
					  items: [
					  {
						item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
						item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
						coupon: "",    //coupon name
						item_brand: "Arena Hotels",    //if the are several brands
						item_category: accommodation_type, // category, // "VIP",
						item_category2: rate.Board, // "B/B",   //Room plan
						item_list_name: accommodation_city, // "Medulin Hotels",
						item_variant: rate.unitName, // "Double Room", //Room type
						price: productPrice,
						quantity: 1,
						location_id: google_places_api_id, // "EhpSVzdRK1BIRiwgTWVkdWxpbiwgQ3JvYXRpYSImOiQKCg0VH7YaFSPpTggQCxoUChIJJUj9_5grY0cRkNMrhlCtAAQ"  // The physical location associated with the item It's recommended to use the Google Place ID that corresponds to the associated item.
					  }
					]
					}
				  }                



			}

		}

		console.log("addToCart dataLayer dataToPush", dataToPush);

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
			// dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		}

	},

	// done
	trackEcommerceRemoveFromCart: function(room, category, variant, currencyCode, props) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(currencyCode === undefined) currencyCode = 'EUR';

		console.log("trackEcommerceRemoveFromCart", arguments);

		if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

			//find chosen rate
			if (room.unitData.rateName.includes(" - ")) {


				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				} else{

					var segments = room.unitData.rateName.split(" - ");

					if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
						var rate = room.unitData.phobsData.rates[segments[0]];
					}
				}


			} else {

				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
				}
			}



			// ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
			var property_id = '';
			var property_name = '';
			var google_places_api_id = '';
			var accommodation_type = '';
			var accommodation_city = '';
			if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
				property_id = room.unitData.savedData.property_id;
			}

			if (props !== undefined && props['property'] !== undefined) {
				var property = props['property'];
				if (property.property_id !== undefined) property_id = property.property_id;
				if (property.name !== undefined) property_name = property.name;

				if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
					if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
					if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
					if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
				}
			}


			if (rate !== undefined) {

				//find the correct rate variation
				if (rate.variations !== undefined) {
					if (rate.variations[room.unitData.board] !== undefined) {
						rate = rate.variations[room.unitData.board];
					} else {
						return;
					}
				}

				// fallback price
				var productPrice = '0';
				if(room.price !== undefined)
				{
					productPrice = parseFloat(room.price);
				}
				else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
					productPrice = rate.specialStayTotal.Price;
				}
				else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
				{
					productPrice = rate.StayTotal.Price;
				}
				else {
					productPrice = rate.Price;
				}


				// 2023 GA4
				var dataToPush = {
					event: "remove_from_cart",
					ecommerce: {
					  currency: currencyCode, // EUR
					 value: productPrice,    
					  items: [
					  {
						item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
						item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
						coupon: "",    //coupon name
						item_brand: "Arena Hotels",    //if the are several brands
						item_category: accommodation_type, // category, // "VIP",
						item_category2: rate.Board, // "B/B",   //Room plan
						item_list_name: accommodation_city, // "Medulin Hotels",
						item_variant: rate.unitName, // "Double Room", //Room type
						price: productPrice,
						quantity: 1,
						location_id: google_places_api_id, // "EhpSVzdRK1BIRiwgTWVkdWxpbiwgQ3JvYXRpYSImOiQKCg0VH7YaFSPpTggQCxoUChIJJUj9_5grY0cRkNMrhlCtAAQ"  // The physical location associated with the item It's recommended to use the Google Place ID that corresponds to the associated item.
					  }
					]
					}
				  }                

			}

		}

		console.log("removeFromCart dataLayer dataToPush", dataToPush);
		if(typeof dataLayer !== 'undefined')
		{
			// dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		}

	},

	// done
	trackEcommerceCheckout: function(rooms, category, variant, currencyCode, props, cb) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(currencyCode === undefined) currencyCode = 'EUR';
		if (cb === undefined) cb = function () { };
		var revenue = 0;

		// console.log("trackEcommerceCheckout", arguments);

		var products = [];
		for(var i=0;i<rooms.length;i++){

			var room = rooms[i];

			if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

				//find chosen rate
				if (room.unitData.rateName.includes(" - ")) {

					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					} else{

						var segments = room.unitData.rateName.split(" - ");

						if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
							var rate = room.unitData.phobsData.rates[segments[0]];
						}
					}


				} else {

					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					}
				}

				// ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
				var property_id = '';
				var property_name = '';
				var google_places_api_id = '';
				var accommodation_type = '';
				var accommodation_city = '';
				if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
					property_id = room.unitData.savedData.property_id;
				}

				if (props !== undefined && props['property'] !== undefined) {
					var property = props['property'];
					if (property.property_id !== undefined) property_id = property.property_id;
					if (property.name !== undefined) property_name = property.name;

					if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
						if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
						if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
						if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
					}
				}

				if(rate !== undefined) {

					//find the correct rate variation
					if(rate.variations !== undefined) {
						if (rate.variations[room.unitData.board] !== undefined) {
							rate = rate.variations[room.unitData.board];
						} else {
							continue;
						}
					}

					// fallback price
					var productPrice = '0';
					if(room.price !== undefined)
					{
						productPrice = parseFloat(room.price);
					}
					else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
						productPrice = rate.specialStayTotal.Price;
					}
					else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
					{
						productPrice = rate.StayTotal.Price;
					}
					else {
						productPrice = rate.Price;
					}

					revenue += productPrice;

					// 2023 GA4
					var product = {
						item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
						item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
						coupon: "",    //coupon name
						item_brand: "Arena Hotels",    //if the are several brands
						item_category: accommodation_type, // category, // "VIP",
						item_category2: rate.Board, // "B/B",   //Room plan
						item_list_name: accommodation_city, // "Medulin Hotels",
						item_variant: rate.unitName, // "Double Room", //Room type
						price: productPrice,
						quantity: 1,
						location_id: google_places_api_id, 
					};                    

					products.push(product);
				}
			}
		}

		var dataToPush = {
			'event': 'begin_checkout',
			'ecommerce': {
				'currency': currencyCode,
				'value': revenue,
				'items': products,
			}
		};


		if(cb)
		{
			dataToPush.eventCallback = cb;
		}

		console.log("trackEcommerceCheckout dataLayer dataToPush", dataToPush);
		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
			// dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push(dataToPush);
		} else {
			cb();
		}
	},

	// done
	trackEcommercePurchase: function(order, rooms, category, variant, currencyCode, props, cb) {

		// if(dimensions === undefined) dimensions = null;
		if(category === undefined) category = 'Hotel';
		if(variant === undefined) variant = '';
		if(currencyCode === undefined) currencyCode = 'EUR';
		if(cb === undefined) cb = function() {};

		var revenue = 0;

		var reservedRooms = [];

		//use rooms from the order object that contain phobs reservationID
		for(var i = 0; i < order.rooms.length; i++) {
			var reservationID = order.rooms[i][0]['reservationID'];

			for (var j = 0; j < order.rooms[i].length; j++) {
				order.rooms[i][j].reservationID = reservationID;
				reservedRooms.push(order.rooms[i][j]);
			}
		}

		var products = [];
		for (var i = 0; i < reservedRooms.length;i++){

			var room = reservedRooms[i];

			if (room.isFilled && room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {
				//find chosen rate
				if (room.unitData.rateName.includes(" - ")) {


					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					} else{

						var segments = room.unitData.rateName.split(" - ");

						if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
							var rate = room.unitData.phobsData.rates[segments[0]];
						}
					}


				} else {

					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
					}
				}

				// ga4 2023 update - get phobs hotel id (property id) from vudu content article for room/unit 
				var property_id = '';
				var property_name = '';
				var google_places_api_id = '';
				var accommodation_type = '';
				var accommodation_city = '';
				if (room['unitData']['savedData'] !== undefined && room['unitData']['savedData'].property_id !== undefined ) {
					property_id = room.unitData.savedData.property_id;
				}

				if (props !== undefined && props['property'] !== undefined) {
					var property = props['property'];
					if (property.property_id !== undefined) property_id = property.property_id;
					if (property.name !== undefined) property_name = property.name;

					if (property.articleData !== undefined && property.articleData.custom_fields !== undefined) {
						if (property.articleData.custom_fields.google_places_api_id !== undefined) google_places_api_id = property.articleData.custom_fields.google_places_api_id
						if (property.articleData.custom_fields.accommodation_type !== undefined) accommodation_type = property.articleData.custom_fields.accommodation_type
						if (property.articleData.custom_fields.accommodation_city !== undefined) accommodation_city = property.articleData.custom_fields.accommodation_city
					}
				}  

				if(rate !== undefined) {

					//find the correct rate variation
					if(rate.variations !== undefined) {
						if (rate.variations[room.unitData.board] !== undefined) {
							rate = rate.variations[room.unitData.board];
						} else {
							return;
						}
					}

					// fallback price
					var productPrice = 0;
					// var productPrice = '0'; // "0380.30" bug /facepalm

					if (order.coupon == "" && room.priceWithoutLoyalty !== undefined) {
						productPrice = parseFloat(room.priceWithoutLoyalty);
					} else if(room.price !== undefined) {
						productPrice = parseFloat(room.price);
					}
					else if (order.coupon !== "" && rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
						productPrice = parseFloat(rate.specialStayTotal.Price);
					}
					else if(rate.StayTotal.Price !== undefined) {
						productPrice = parseFloat(rate.StayTotal.Price);
					}

					revenue += productPrice;

					// 2023 GA4
					var product = {
						item_id: property_id, // "3f1a7633c89aef28a465b8246d828d75", // phobs proeprty id   //hotel ID
						item_name: property_name, // hotelName, // "Arena Hotel Holiday",   //hotel name
						coupon: "",    //coupon name
						item_brand: "Arena Hotels",    //if the are several brands
						item_category: accommodation_type, // category, // "VIP",
						item_category2: rate.Board, // "B/B",   //Room plan
						item_list_name: accommodation_city, // "Medulin Hotels",
						item_variant: rate.unitName, // "Double Room", //Room type
						price: productPrice,
						quantity: 1,
						location_id: google_places_api_id, 
					};        
					products.push(product);
				}
			}
		}

		var dataToPush = {
			'event': 'purchase',
			'ecommerce': {
				'transaction_id': order.orderId,                         // Transaction ID. Required for purchases and refunds.
				'currency': currencyCode,
				'value': revenue,
				'coupon': order.coupon,
				'items': products,
			}
		};

		console.log("trackEcommercePurchase dataLayer dataToPush", dataToPush);

		if(cb)
		{
			dataToPush.eventCallback = cb;
		}

		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
		{
	  
			dataLayer.push(dataToPush);
		} else {
			cb();
		}
	}

};




















// // mora biti window.gtm_Tracking jer ga koristi Vue
// window.gtm_Tracking = {

// 	init: function() {

// 		this.bindTrackAnchor();

// 	},

// 	bindTrackAnchor: function() {

// 		var self = this;

// 		if($("a.gtm-event").length > 0)
// 		{
// 			$("a.gtm-event").each(function(){

// 				$(this).on("click", function(e){


// 					var anchorHref = $(this).attr("href");
// 					var eventCategory = $(this).attr("data-ga-category");
// 					var eventAction = $(this).attr("data-ga-action");
// 					var eventLabel = $(this).attr("data-ga-label");
// 					var eventValue = $(this).attr("data-ga-value");
// 					var eventNonInteraction = $(this).attr("data-ga-noninteraction");
// 					var eventOutbound = $(this).attr("data-ga-outbound") == undefined ? false : true;
// 					var callbackFunction = false;

// 					////console.log("a.gtm-event", anchorHref, eventOutbound);

// 					if(eventCategory!==undefined && eventCategory!="" && eventAction!==undefined && eventAction!="")
// 					{
// 						if(!eventOutbound)
// 						{
// 							e.preventDefault();
// 							callbackFunction = function(){
// 								location.href = anchorHref;
// 							}
// 						}

// 						self.trackEvent(eventCategory, eventAction, eventLabel, eventValue, eventNonInteraction, callbackFunction);
// 					}
// 				});

// 			});
// 		}

// 		var filetypes = /\.(zip|exe|pdf|doc*|xls*|ppt*|mp3)$/i;
//         var baseHref = '';
//         if (jQuery('base').attr('href') != undefined) baseHref = jQuery('base').attr('href');

//         jQuery('a:not(.gtm-event)').each(function() {

//             var href = jQuery(this).attr('href');

//             if (href && href.match(/^mailto\:/i))
//             {
//                 jQuery(this).click(function() {
//                     var mailLink = href.replace(/^mailto\:/i, '');

//                     // ga tracking
//                     gtm_Tracking.trackEvent('Email', 'click', mailLink, 1);
//                 });
//             }
//             else if (href && href.match(filetypes))
//             {
//                 jQuery(this).click(function(e) {
//                     var extension = (/[.]/.exec(href)) ? "-" + /[^.]+$/.exec(href) : '';

//                     // ga tracking
//                     gtm_Tracking.trackEvent('Download', 'click' + extension, href, 1);
//                 });
//             }

//         });

// 	},

// 	/**
// 	 * gtm_Tracking.trackEvent('test', 'console', 'Arena', 1);
// 	 *
// 	 * dataLayer.push({"event":"GAEvent","eventCategory":"test","eventAction":"console","eventLabel":"Arena","eventValue":1});
// 	 */
// 	trackEvent: function(category, action, label, value, noninteraction, cb) {

// 		////console.log("trackEvent", category, action, label);

// 		var eventLabel = label == undefined ? '' : label;
// 		var eventValue = value == undefined ? '' : value;
// 		var eventNonInteraction = noninteraction == undefined ? false : noninteraction;
// 		var callbck = cb == undefined ? false : cb;

// 		var obj = {
// 			'event': 'GAEvent',
// 			'eventCategory': category,
// 			'eventAction': action,
// 			'eventLabel': eventLabel,
// 			'eventValue': eventValue,
// 			'eventNonInteraction': eventNonInteraction
// 		};

// 		if(callbck)
// 		{
// 			obj.eventCallback = callbck;
// 		}

// 		if(typeof dataLayer !== 'undefined')
// 		{
// 			dataLayer.push(obj);
// 		}
// 	},

//     // old ga3
//     // ne koristi se trenutno nigdje (ne poziva se iz vue bookinga)	
// 	trackNetwork: function(category, action, target) {

// 		////console.log("trackNetwork", category, action, target);
// 		if(typeof dataLayer !== 'undefined')
// 		{
// 			dataLayer.push({
// 				'event': 'GAEvent',
// 				'socialNetwork': category,
// 				'socialAction': action,
// 				'socialTarget': target
// 			});
// 		}

// 	},

// 	// Ecommerce Measurement

//     // old ga3 
//     // ne koristi se trenutno nigdje (ne poziva se iz vue bookinga)
// 	trackEcommerceProductImpressions: function(products, category, variant, list, currencyCode) {

// 		if(category === undefined) category = 'Hotel';
// 		if(variant === undefined) variant = '';
// 		if(list === undefined) list = 'Hotel room list';
// 		if(currencyCode === undefined) currencyCode = 'EUR';

// 		var dataToPush = {
// 			'ecommerce': {
// 				'currencyCode': currencyCode, // Local currency is optional.
// 				'impressions': []
// 			}
// 		};

// 		products.forEach(function(element, index) {

// 			var itemToPush = {
// 				'name': element['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
// 				'id': element['id'], // '12345',
// 				'price': element['price'], // '15.25',
// 				'brand': 'Arenahotels', // 'Google',
// 				'category': category, // 'Apparel',
// 				'variant': variant, // 'Gray',
// 				'list': list, // 'Search Results',
// 				'position': index+1
// 			};

// 			dataToPush.ecommerce.impressions,push(itemToPush);

// 		});

// 		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
// 		{
// 			dataLayer.push(dataToPush);
// 		}

// 	},

// 	// done
// 	trackEcommerceAddToCart: function(room, category, hotelName, currencyCode, dimensions) {

// 		if(dimensions === undefined) dimensions = null;
// 		if(category === undefined) category = 'Hotel';
// 		if(hotelName === undefined) hotelName = '';
// 		if(currencyCode === undefined) currencyCode = 'EUR';

// 		// console.log("trackEcommerceAddToCart", arguments);

// 		if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

// 			//find chosen rate
// 			if (room.unitData.rateName.includes(" - ")) {


// 				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 				} else{

// 					var segments = room.unitData.rateName.split(" - ");

// 					if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
// 						var rate = room.unitData.phobsData.rates[segments[0]];
// 					}
// 				}


// 			} else {

// 				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 				}
// 			}


// 			if (rate !== undefined) {

// 				//find the correct rate variation
// 				if (rate.variations !== undefined) {
// 					if (rate.variations[room.unitData.board] !== undefined) {
// 						rate = rate.variations[room.unitData.board];
// 					} else {
// 						return;
// 					}
// 				}

// 				// fallback price
// 				var productPrice = '0';
// 				if(room.price !== undefined)
// 				{
// 					productPrice = parseFloat(room.price);
// 				}
// 				else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
// 					productPrice = rate.specialStayTotal.Price;
// 				}
// 				else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
// 				{
// 					productPrice = rate.StayTotal.Price;
// 				}
// 				else
// 				{
// 					productPrice = rate.Price;
// 				}

// 				var dataToPush = {
// 					'event': 'addToCart',
// 					'ecommerce': {
// 						'currencyCode': currencyCode,
// 						'add': { // 'add' actionFieldObject measures.
// 							'products': [{
// 								'name': hotelName, // 'Triblend Android T-Shirt', // Name or ID is required.
// 								'id': room['unitData']['unitID'], // '12345',
// 								'price': productPrice.toString(), // '15.25',
// 								'brand': 'Arenahotels', // 'Google',
// 								'category': category, // 'Apparel',
// 								'variant': rate.Board, // 'Gray',
// 								'quantity': 1,
// 								'dimension1': 'nights',
// 								'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
// 								'dimension2': 'avaragePrice',
// 								'metric2': parseFloat(rate.Price).toString()
// 							}]
// 						}
// 					}
// 				};
// 			}

// 		}

// 		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
// 		{

// 			dataLayer.push(dataToPush);
// 		}

// 	},

// 	// done
// 	trackEcommerceRemoveFromCart: function(room, category, variant, currencyCode, dimensions) {

// 		if(dimensions === undefined) dimensions = null;
// 		if(category === undefined) category = 'Hotel';
// 		if(variant === undefined) variant = '';
// 		if(currencyCode === undefined) currencyCode = 'EUR';

// 		if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

// 			//find chosen rate
// 			if (room.unitData.rateName.includes(" - ")) {


// 				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 				} else{

// 					var segments = room.unitData.rateName.split(" - ");

// 					if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
// 						var rate = room.unitData.phobsData.rates[segments[0]];
// 					}
// 				}


// 			} else {

// 				if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 					var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 				}
// 			}

// 			if (rate !== undefined) {

// 				//find the correct rate variation
// 				if (rate.variations !== undefined) {
// 					if (rate.variations[room.unitData.board] !== undefined) {
// 						rate = rate.variations[room.unitData.board];
// 					} else {
// 						return;
// 					}
// 				}

// 				// fallback price
// 				var productPrice = '0';
// 				if(room.price !== undefined)
// 				{
// 					productPrice = parseFloat(room.price);
// 				}
// 				else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
// 					productPrice = rate.specialStayTotal.Price;
// 				}
// 				else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
// 				{
// 					productPrice = rate.StayTotal.Price;
// 				}
// 				else {
// 					productPrice = rate.Price;
// 				}

// 				var dataToPush = {
// 					'event': 'removeFromCart',
// 					'ecommerce': {
// 						'currencyCode': currencyCode,
// 						'remove': { // 'add' actionFieldObject measures.
// 							'products': [{
// 								'name': variant, // 'Triblend Android T-Shirt', // Name or ID is required.
// 								'id': room['unitData']['unitID'], // '12345',
// 								'price': productPrice.toString(), // '15.25',
// 								'brand': 'Arenahotels', // 'Google',
// 								'category': category, // 'Apparel',
// 								'variant': rate.Board, // 'Gray',
// 								'quantity': 1,
// 								'dimension1': 'nights',
// 								'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
// 								'dimension2': 'avaragePrice',
// 								'metric2': parseFloat(rate.Price).toString()
// 							}]
// 						}
// 					}
// 				};

// 			}

// 		}

// 		if(typeof dataLayer !== 'undefined')
// 		{

// 			dataLayer.push(dataToPush);
// 		}

// 	},

// 	// done
// 	trackEcommerceCheckout: function(rooms, category, variant, currencyCode, dimensions, cb) {

// 		if(dimensions === undefined) dimensions = null;
// 		if(category === undefined) category = 'Hotel';
// 		if(variant === undefined) variant = '';
// 		if(currencyCode === undefined) currencyCode = 'EUR';
// 		if (cb === undefined) cb = function () { };

// 		// console.log("trackEcommerceCheckout", arguments);

// 		var products = [];
// 		for(var i=0;i<rooms.length;i++){

// 			var room = rooms[i];

// 			if (room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {

// 				//find chosen rate
// 				if (room.unitData.rateName.includes(" - ")) {

// 					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 					} else{

// 						var segments = room.unitData.rateName.split(" - ");

// 						if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
// 							var rate = room.unitData.phobsData.rates[segments[0]];
// 						}
// 					}


// 				} else {

// 					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 					}
// 				}

// 				if(rate !== undefined) {

// 					//find the correct rate variation
// 					if(rate.variations !== undefined) {
// 						if (rate.variations[room.unitData.board] !== undefined) {
// 							rate = rate.variations[room.unitData.board];
// 						} else {
// 							continue;
// 						}
// 					}

// 					// fallback price
// 					var productPrice = '0';
// 					if(room.price !== undefined)
// 					{
// 						productPrice = parseFloat(room.price);
// 					}
// 					else if (rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
// 						productPrice = rate.specialStayTotal.Price;
// 					}
// 					else if (rate.StayTotal !== undefined && rate.StayTotal.Price !== undefined)
// 					{
// 						productPrice = rate.StayTotal.Price;
// 					}
// 					else {
// 						productPrice = rate.Price;
// 					}

// 					var product = {
// 						'name': variant, //room['unitData']['phobsData']['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
// 						'id': room['unitData']['unitID'], // '12345',
// 						'price': productPrice.toString(), // '15.25',
// 						'brand': 'Arenahotels', // 'Google',
// 						'category': category, // 'Apparel',
// 						'variant': rate.Board, // 'Gray',
// 						'quantity': 1,
// 						'dimension1': 'nights',
// 						'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
// 						'dimension2': 'avaragePrice',
// 						'metric2': parseFloat(rate.Price).toString(),
// 						'dimension3': 'adults',
// 						'metric3': room.adults.toString(),
// 						'dimension4': 'children',
// 						'metric4': room.children.length.toString()
// 					};

// 					products.push(product);
// 				}
// 			}
// 		}



// 		var dataToPush = {
// 			'event': 'checkout',
// 			'ecommerce': {
// 				'checkout': {
// 					'actionField': {'step': 1, 'option': ''},
// 					'products': products
// 				}
// 			}
// 		};

// 		if(cb)
// 		{
// 			dataToPush.eventCallback = cb;
// 		}

// 		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
// 		{
// 			dataLayer.push(dataToPush);
// 		} else {
// 			cb();
// 		}
// 	},

// 	// done
// 	trackEcommercePurchase: function(order, rooms, category, variant, currencyCode, dimensions, cb) {

// 		if(dimensions === undefined) dimensions = null;
// 		if(category === undefined) category = 'Hotel';
// 		if(variant === undefined) variant = '';
// 		if(currencyCode === undefined) currencyCode = 'EUR';
// 		if(cb === undefined) cb = function() {};

// 		var revenue = 0;

// 		var reservedRooms = [];

// 		//use rooms from the order object that contain phobs reservationID
// 		for(var i = 0; i < order.rooms.length; i++) {
// 			var reservationID = order.rooms[i][0]['reservationID'];

// 			for (var j = 0; j < order.rooms[i].length; j++) {
// 				order.rooms[i][j].reservationID = reservationID;
// 				reservedRooms.push(order.rooms[i][j]);
// 			}
// 		}

// 		var products = [];
// 		for (var i = 0; i < reservedRooms.length;i++){

// 			var room = reservedRooms[i];

// 			if (room.isFilled && room['unitData'] !== undefined && room['unitData'].rate !== undefined && room.unitData.rateName !== undefined) {
// 				//find chosen rate
// 				if (room.unitData.rateName.includes(" - ")) {


// 					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 					} else{

// 						var segments = room.unitData.rateName.split(" - ");

// 						if (room.unitData.phobsData.rates[segments[0]] !== undefined) {
// 							var rate = room.unitData.phobsData.rates[segments[0]];
// 						}
// 					}


// 				} else {

// 					if (room.unitData.phobsData.rates[room.unitData.rateName] !== undefined) {
// 						var rate = room.unitData.phobsData.rates[room.unitData.rateName];
// 					}
// 				}

// 				if(rate !== undefined) {

// 					//find the correct rate variation
// 					if(rate.variations !== undefined) {
// 						if (rate.variations[room.unitData.board] !== undefined) {
// 							rate = rate.variations[room.unitData.board];
// 						} else {
// 							return;
// 						}
// 					}

// 					// fallback price
// 					var productPrice = '0';

// 					if (order.coupon == "" && room.priceWithoutLoyalty !== undefined) {
// 						productPrice = parseFloat(room.priceWithoutLoyalty);
// 					} else if(room.price !== undefined) {
// 						productPrice = parseFloat(room.price);
// 					}
// 					else if (order.coupon !== "" && rate.specialStayTotal !== undefined && rate.specialStayTotal.Price !== undefined) {
// 						productPrice = rate.specialStayTotal.Price;
// 					}
// 					else if(rate.StayTotal.Price !== undefined) {
// 						productPrice = rate.StayTotal.Price;
// 					}

// 					revenue += productPrice;

// 					var product = {
// 						'name': variant, //room['unitData']['phobsData']['name'], // 'Triblend Android T-Shirt', // Name or ID is required.
// 						'id': room['unitData']['unitID'], // '12345',
// 						'price': productPrice.toString(), // '15.25',
// 						'brand': 'Arenahotels', // 'Google',
// 						'category': category, // 'Apparel',
// 						'variant': rate.Board, // 'Gray',
// 						'quantity': 1,
// 						'dimension1': 'nights',
// 						'metric1': rate.PriceBreakdown.PriceDay.length !== undefined ? rate.PriceBreakdown.PriceDay.length.toString() : '0',
// 						'dimension2': 'avaragePrice',
// 						'metric2': parseFloat(rate.Price).toString(),
// 						'dimension3': 'adults',
// 						'metric3': room.adults.toString(),
// 						'dimension4': 'children',
// 						'metric4': room.children.length.toString(),
// 						'dimension5': room.reservationID,
// 						'metric5': 0
// 					};

// 					products.push(product);
// 				}
// 			}
// 		}


// 		var dataToPush = {
// 			'event': 'purchase',
// 			'ecommerce': {
// 				'purchase': {
// 					'actionField': {
// 						'id': order.orderId,                         // Transaction ID. Required for purchases and refunds.
// 						'affiliation': 'Phobs Booking',
// 						'revenue': revenue,                     // Total transaction value (incl. tax and shipping)
// 						'tax':'0.00',
// 						'shipping': '0.00',
// 						'coupon': order.coupon
// 					},
// 					'products': products
// 				}
// 			}
// 		};

// 		if(cb)
// 		{
// 			dataToPush.eventCallback = cb;
// 		}

// 		if(typeof dataLayer !== 'undefined' && dataToPush !== undefined)
// 		{
// 			dataLayer.push(dataToPush);
// 		} else {
// 			cb();
// 		}
// 	}

// };


